<template>
  <!-- 图片维护 -->
  <div class="imgMan">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['权限管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('')"
          >添加</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="状态"
          style="width: 100px; margin-right: 5px"
        >
          <el-option label="全部" value="9"></el-option>
          <el-option label="已上架" value="2"></el-option>
          <el-option label="未上架" value="1"></el-option>
        </el-select>
        <label class="label">设备类型：</label>
        <el-select
          v-model="searchForm.type"
          placeholder="设备类型"
          style="width: 100px; margin-right: 5px"
          @change="getImgType(1, true)"
        >
          <el-option label="通用" value="ALL"></el-option>
          <el-option label="PC端" value="PC"></el-option>
          <el-option label="APP端" value="APP"></el-option>
        </el-select>
        <label class="label">图片分类：</label>
        <el-select
          v-model="searchForm.imgType"
          placeholder="图片分类"
          style="width: 100px; margin-right: 5px"
        >
          <el-option
            v-for="item in imgTypeList"
            :key="item.ImgType"
            :label="item.TypeName"
            :value="item.ImgType"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          @keyup.enter.native="getTableData"
          clearable
          placeholder="输入编号/名称"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="id"
        show-overflow-tooltip
        label="图片编号"
      >
      </el-table-column>
      <el-table-column
        prop="sort_id"
        align="center"
        show-overflow-tooltip
        label="排序"
      >
      </el-table-column>
      <el-table-column
        prop="typeName"
        label="图片分类"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="title"
        label="图片标题"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="source"
        label="类别"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="ejTypeName"
        label="一级分类"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="beizhu"
        label="备注"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="add_time"
        label="创建日期"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <el-button
            v-show="scope.row.status == 2"
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 1)"
            >下架</el-button
          >
          <el-button
            v-show="scope.row.status == 1"
            type="success"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 2)"
            >上架</el-button
          >
          <el-button
            v-show="scope.row.status == 1 || scope.row.status == 2"
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-show="scope.row.status == 1"
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 0)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 新增图片 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">新增图片</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="130px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="标题" prop="title">
              <el-input v-model="addForm.title" clearable></el-input>
            </el-form-item>
            <el-form-item
              label="所属类别"
              prop="imgType"
              class="el-form-required-true"
              v-show="!addForm.id"
            >
              <el-select
                v-model="addForm.imgType"
                placeholder="所属类别"
                style="width: 100%"
                @change="getImgType(1, false)"
              >
                <el-option label="通用" value="ALL"></el-option>
                <el-option label="PC端" value="PC"></el-option>
                <el-option label="APP端" value="APP"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="图片一级分类"
              prop="imgTypeOne"
              class="el-form-required-true"
              v-show="!addForm.id"
            >
              <el-select
                v-model="addForm.imgTypeOne"
                placeholder="图片一级分类"
                style="width: 100%"
                @change="getImgType(2, false)"
              >
                <el-option
                  v-for="item in imgTypeOne"
                  :key="item.ImgType"
                  :label="item.TypeName"
                  :value="item.ImgType"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="图片二级分类"
              prop="imgTypeTwo"
              class="el-form-required-true"
              v-show="!addForm.id"
            >
              <el-select
                v-model="addForm.imgTypeTwo"
                placeholder="图片二级分类"
                style="width: 100%"
              >
                <el-option
                  v-for="item in imgTypeTwo"
                  :key="item.ImgType"
                  :label="item.TypeName"
                  :value="item.ImgType"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择图片" prop="imgUrl">
              <img-view :imgList="[{ url: imgCover, id: 0 }]"></img-view>
              <upload
                @fileChange="imgUpdata"
                accept="image/jpg,image/jpeg,image/png"
              ></upload>
            </el-form-item>
            <el-form-item label="电脑端跳转链接" prop="pcLink">
              <el-input v-model="addForm.pcLink" clearable></el-input>
            </el-form-item>
            <el-form-item label="移动端跳转类型" prop="appType">
              <el-select
                v-model="addForm.appType"
                placeholder="移动端跳转类型"
                style="width: 100%"
              >
                <el-option label="无跳转" value="0"></el-option>
                <el-option label="商品详情" value="1"></el-option>
                <el-option label="模块" value="2"></el-option>
                <el-option label="商品分类" value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="移动端商品编号"
              prop="appGoods"
              v-show="addForm.appType == 1"
              class="el-form-required-true"
            >
              <el-input
                v-model="addForm.appGoods"
                clearable
                placeholder="移动端商品编号"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="移动端跳转模块"
              prop="appMode"
              v-if="addForm.appType == 2"
              class="el-form-required-true"
            >
              <el-select
                v-model="addForm.appMode"
                placeholder="移动端跳转模块"
                style="width: 100%"
              >
                <el-option
                  v-for="item in appModeList"
                  :key="item.id"
                  :label="item.TypeName"
                  :value="item.ImgType"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="移动端商品分类"
              prop="appGoodsSort"
              v-show="addForm.appType == 4"
              class="el-form-required-true"
            >
              <el-input
                v-model="addForm.appGoodsSortName"
                placeholder="单击选择"
                readonly
                @click.native="getGoodsSort('')"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="des">
              <el-input v-model="addForm.des" clearable></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input-number
                v-model="addForm.sort"
                :min="0"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
    <!-- 数据选择 -->
    <tableDialog
      v-if="goodsSort.isShow"
      title="商品分类(二级分类)"
      :tableData="goodsSort.tableData"
      :tableHead="goodsSort.tableDataHead"
      :currPage.sync="goodsSort.currPage"
      :allPage="goodsSort.allPage"
      @search="getGoodsSort"
      @rowClick="goodsSortSel"
      @hanCurrChange="goodsSortPage"
      @close="goodsSort.isShow = false"
    ></tableDialog>
  </div>
</template>

<script>
import { mustFill } from "@/mixins/data/valid.js"; //混入表单必填项

export default {
  name: "imgMan",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      imgTypeList: [], //图片分类
      imgTypeOne: [], //图片一级分类
      imgTypeTwo: [], //图片二级分类
      appModeList: [], //移动端跳转模块
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        status: "9",
        type: "PC",
        imgType: "",
        name: "",
      },
      /**新增drawer */
      addDrawer: false,
      imgCover: "",
      /**新增表单 */
      addForm: {
        id: "", // 图片编号
        title: "", // 标题
        imgType: "", // 所属类别
        imgTypeOne: "", // 图片一级分类
        imgTypeTwo: "", // 图片二级分类
        imgUrl: "", // 图片地址
        pcLink: "", // 电脑端跳转链接
        appType: "0", //移动端跳转类型
        appGoods: "", //移动端商品编号
        appMode: "", //移动端跳转模块
        appGoodsSort: "", //移动端商品分类
        appGoodsSortName: "", //移动端商品分类名称
        des: "", // 备注
        sort: "", // 排序
      },
      /**新增表单规则 */
      addFormRule: {
        title: [mustFill], // 标题
        imgType: [this.imgTypeFill()], // 所属类别
        imgTypeOne: [this.imgTypeFill()], // 图片一级分类
        imgTypeTwo: [this.imgTypeFill()], // 图片二级分类
        imgUrl: [mustFill], // 图片地址
        appType: [mustFill], // 移动端跳转类型
        appGoods: [this.appLinkFill("appType", 1)], //移动端商品编号
        appMode: [this.appLinkFill("appType", 2)], //移动端跳转模块
        appGoodsSort: [this.appLinkFill("appType", 4)], //移动端商品分类
        sort: [mustFill], // 排序
      },
      goodsSort: {
        isShow: false,
        name: "",
        tableData: [],
        tableDataHead: {},
        currPage: 1,
        allPage: 1,
      },
    };
  },
  mounted() {
    this.getTableData();
    this.getAppUrl();
    this.getImgType(1, true);
  },
  methods: {
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GetImgList",
        status: this.searchForm.status,
        source: this.searchForm.type,
        imgType: this.searchForm.imgType,
        title: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Img"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "main/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "Post",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    //移动端跳转模块获取
    getAppUrl() {
      var data = {
        type: "GetImgType",
        source: "APP",
        jibie: 2,
        imgType: "APPModule",
      };
      var proc = "Proc_Admin_Img"; //存储过程名
      var type = "ReturnList";
      this.$requestSys({
        url:
          "brand/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "Post",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.appModeList = res.data;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    //图片一级二级分类
    getImgType(level, isSearch) {
      let data = {
        type: "GetImgType",
        source: isSearch ? this.searchForm.type : this.addForm.imgType,
        jibie: level,
        imgType: level == 2 ? this.addForm.imgTypeOne : "",
      };
      let proc = "Proc_Admin_Img"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "brand/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "Post",
      })
        .then((res) => {
          console.log(res);
          if (res.flag == 0) {
            if (level == 2) {
              this.imgTypeTwo = res.data;
              this.addForm.imgTypeTwo = "";
            } else {
              if (isSearch) {
                this.imgTypeList = res.data;
                this.searchForm.imgType = "";
              } else {
                this.imgTypeOne = res.data;
                this.addForm.imgTypeOne = "";
                this.addForm.imgTypeTwo = "";
              }
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**点击新增 */
    handleAdd(row) {
      this.clearForm();
      if (row) {
        this.addForm.id = row.id;
        this.getImgData(row);
      }
      this.addDrawer = true;
    },
    // 分类控制验证
    imgTypeFill() {
      return {
        validator: (rule, value, callback) => {
          if (!this.addForm.id) {
            if (!value) {
              return callback(new Error("该字段为必填项"));
            } else {
              return callback();
            }
          } else {
            return callback();
          }
        },
        trigger: "blur",
      };
    },
    // 移动端跳转链接控制验证
    appLinkFill(key, keyValue) {
      return {
        validator: (rule, value, callback) => {
          if (this.addForm[key] == keyValue) {
            if (!value) {
              return callback(new Error("该字段为必填项"));
            } else {
              return callback();
            }
          } else {
            return callback();
          }
        },
      };
    },
    //获取图片详情
    getImgData(row) {
      let data = {
        type: "QueryImg",
        id: row.id,
      };
      let proc = "Proc_Admin_Img"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "brand/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "Post",
      })
        .then((res) => {
          if (res.flag == 0) {
            let data = res.data[0];
            this.addForm.title = data.title;
            this.addForm.imgType = data.source;
            this.addForm.imgTypeOne = data.ImgType;
            this.addForm.imgTypeTwo = data.imgTypeS;
            this.addForm.imgUrl = data.img_url;
            this.imgCover = this.$setImgUrl(data.img_url);
            this.addForm.pcLink = data.link_url;
            this.addForm.appType = data.androidlinktype;
            if (this.addForm.appType == 1) {
              this.addForm.appGoods = data.androidlinkurl;
            } else if (this.addForm.appType == 2) {
              this.addForm.appMode = data.androidlinkurl;
            } else if (this.addForm.appType == 4) {
              this.addForm.appGoodsSort = data.androidlinkurl;
              this.addForm.appGoodsSortName = data.Name;
            }
            this.addForm.des = data.beizhu;
            this.addForm.sort = data.Sort_id;
          }
          // 获取成功后价格导航菜单的数据存放在vuex中，方便调用
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    //上架下架删除请求
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let msgType = "info";
      if (status == 2) {
        msg = "确定上架吗?";
        msgType = "success";
      } else if (status == 1) {
        msg = "确定下架吗?";
        msgType = "warning";
      } else if (status == 0) {
        msg = "确定删除吗?";
        msgType = "error";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: msgType,
      })
        .then(() => {
          let data = {
            type: "AuditImg",
            id: row.id,
            status: status,
          };
          let proc = "Proc_Admin_Img"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "brand/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "Post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**图片上传 */
    imgUpdata(file) {
      if (file.length) {
        this.imgCover = URL.createObjectURL(file[0]);
        if (!this.addForm.imgTypeTwo) {
          this.$message({
            message: "上传失败,请选择图片分类",
            type: "info",
          });
          return;
        }
        var formData = new FormData();
        formData.append("uploadfile", file[0]);
        this.$uploadRequest({
          method: "post",
          url:
            "admin/ashx/UploadImg.ashx?type=UploadImage&imgType=" +
            this.addForm.imgTypeTwo,
          data: formData,
        })
          .then((res) => {
            this.addForm.imgUrl = res.message;
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },
    // 获取商品分类
    getGoodsSort(val, isRep) {
      this.goodsSort.name = isRep ? val : this.goodsSort.name;
      this.goodsSort.currPage = isRep ? 1 : this.goodsSort.currPage;
      let data = {
        type: "CategrysListHG",
        PageIndex: this.goodsSort.currPage,
        PageSize: 10,
        strWhere: this.goodsSort.name,
      };
      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      let url =
        "ashx/MainReturnJson.ashx?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&type=" +
        type +
        "&proc=" +
        proc;
      this.$requestSys({
        method: "post",
        url: url,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodsSort.isShow = true;
            this.goodsSort.tableData = res.content;
            this.goodsSort.tableDataHead = res.fdname;
            this.goodsSort.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    goodsSortPage(val) {
      this.goodsSort.currPage = val;
      this.getGoodsSort();
    },
    // 商品分类选择完成
    goodsSortSel(row) {
      this.addForm.appGoodsSort = row.keyid;
      this.addForm.appGoodsSortName = row["分类"];
      this.goodsSort.isShow = false;
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      for (const key in this.addForm) {
        this.addForm[key] = "";
      }
      this.addForm.appType = "0";
      this.imgCover = "";
      this.addDrawer = false;
    },
    /**提交表单 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let androidlinkurl = "";
          if (this.addForm.appType == 1) {
            androidlinkurl = this.addForm.appGoods;
          } else if (this.addForm.appType == 2) {
            androidlinkurl = this.addForm.appMode;
          } else if (this.addForm.appType == 4) {
            androidlinkurl = this.addForm.appGoodsSort;
          }
          let data = {
            type: "Save_Img",
            title: this.addForm.title,
            source: this.addForm.imgType,
            linkUrl: this.addForm.pcLink,
            imgUrl: this.addForm.imgUrl,
            ImgType: this.addForm.imgTypeOne,
            ImgTypeS: this.addForm.imgTypeTwo,
            beizhu: this.addForm.des,
            sort_id: this.addForm.sort,
            urltype: this.addForm.appType,
            androidlinkurl: androidlinkurl,
          };
          if (this.addForm.id) {
            data.type = "UpdateImg";
            data.id = this.addForm.id;
          }
          let proc = "Proc_Admin_Img"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "main/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "Post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
                this.clearForm();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.imgMan {
  width: 100%;
  height: 100%;
}
</style>
